import React from "react";

const Arrow = ({ color, height, width }) => (
  <svg width={width} height={height} viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.9766 9L7.88086 17.0957L6.55762 15.7412L6.21289 15.3877L11.4082 10.1924H0V7.80762H11.4082L6.56152 2.96094L6.21289 2.61133L6.55762 2.25781L7.88086 0.904297L15.9766 9Z"
      fill={color}
    />
  </svg>
);

Arrow.defaultProps = {
  width: 28,
  height: 28,
  color: "white"
};

export default Arrow;
